import { configureStore } from "@reduxjs/toolkit";
import userInfoReducer from "./userInfoSlice";
import profileDataReducer from "./profileDataSlice";
import { localStorageMiddleware } from "./middleware";

export const store = configureStore({
  reducer: {
    userInfo: userInfoReducer,
    profileData: profileDataReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(localStorageMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
